import { locale, loadTranslations } from '$lib/i18n';
export const prerender = false;

export async function load({ url, data }) {
	const { pathname } = url;

	const defaultLocale = data?.language ?? window.navigator.language ?? 'en'; // get from cookie, user session, ...
	locale.set(defaultLocale);
	await loadTranslations(defaultLocale, pathname); // keep this just before the `return`
	return {};
}
